<template>
  <div class="d-flex justify-space-between my-2">
    <div class="w-25 pr-5">
      <v-text-field
        label="Order number"
        v-model="orderNumber"
        @focus="orderNumber = ''"
        @blur="
          orderNumber == '' || orderNumber == null ? (orderNumber = ' ') : ''
        "
        @change="$emit('update:orderNumber', $event)"
        placeholder=" "
        dense
        outlined
        append-icon="shopping_basket"
        hide-details
      >
      </v-text-field>
    </div>
    <div class="w-25 pr-5">
      <v-autocomplete
        :items="suppliers"
        label="Supplier"
        v-model="supplierId"
        @change="$emit('update:supplierId', $event)"
        dense
        outlined
        append-icon="apartment"
        item-text="name"
        item-value="id"
        hide-details
      ></v-autocomplete>
    </div>
    <div class="w-25 pr-5">
      <v-autocomplete
        :items="ratings"
        v-model="rating"
        @change="$emit('update:rating', $event)"
        label="Rating"
        dense
        outlined
        append-icon="tab"
        hide-details
      ></v-autocomplete>
    </div>
    <div class="w-25 text-right">
      <v-btn class="px-2 w-100" color="primary" @click="$emit('apply')"
        >Apply filters</v-btn
      >
    </div>
  </div>
</template>
<script>
export default {
  props: {
    orderNumber: {
      type: String,
      default: " "
    },
    supplierId: {
      type: String,
      default: null
    },
    rating: {
      type: String,
      default: null
    }
  },
  computed: {
    suppliers() {
      let suppliers = this.$store.state.suppliers.suppliers;
      suppliers.unshift({
        name: "",
        id: null
      });
      return suppliers;
    },
    ratings() {
      return [
        {
          text: "1",
          value: 1
        },
        {
          text: "2",
          value: 2
        },
        {
          text: "3",
          value: 3
        },
        {
          text: "4",
          value: 4
        },
        {
          text: "5",
          value: 5
        }
      ];
    }
  },
  async mounted() {
    await this.$store.dispatch("suppliers/LOAD_SUPPLIERS", {
      from: 0,
      to: 0
    });
  },
  data() {
    return {
      paymentStatuses: [
        {
          text: "",
          value: null
        },
        {
          text: "Pending",
          value: "pending"
        },
        {
          text: "Processing",
          value: "processing"
        },
        {
          text: "Processed",
          value: "processed"
        },
        {
          text: "Payment Failed",
          value: "payment_failed"
        }
      ]
    };
  }
};
</script>
